interface CommentItem {
  avatar: string;
  name: string;
  time: string;
  content: string;
  likes: string;
  tag: string;
}

const comments: CommentItem[] = [
  {
    avatar: '🍉',
    name: '吃瓜第一线',
    time: '2 小时前',
    content: '我的天，今天的爆料合集也太猛了吧！顶流恋情那个我觉得八九不离十，之前就有好多蛛丝马迹了。每日大瓜果然是全网吃瓜第一站，每天早八点准时蹲更新！',
    likes: '2.3k',
    tag: '每日爆料吃瓜',
  },
  {
    avatar: '🫣',
    name: '匿名瓜友',
    time: '3 小时前',
    content: '那个综艺翻车的我在现场当观众，比爆出来的还精彩十倍！但是签了保密协议不能多说，只能说节目组确实在压热度。等后续爆料吧，绝对还有大瓜。',
    likes: '1.8k',
    tag: '娱乐爆料',
  },
  {
    avatar: '👀',
    name: '圈内小透明',
    time: '5 小时前',
    content: '关于网红偷税那个，我只能说这次查的不是一个两个，后面还会有一串。各位吃瓜群众坐稳了，这个瓜田今年收成特别好，每日汇总根本写不完。',
    likes: '3.1k',
    tag: '网友爆料',
  },
  {
    avatar: '🔥',
    name: '热心群众王大哥',
    time: '6 小时前',
    content: '我每天最大的快乐就是打开每日大瓜看看今天又有什么新瓜。比刷短视频还有意思，文字截图摘要的形式很友好，上班摸鱼必备，吃瓜新鲜感拉满！',
    likes: '976',
    tag: '吃瓜每日',
  },
  {
    avatar: '🤫',
    name: '深夜吃瓜人',
    time: '8 小时前',
    content: '那个主持人在后台的事我朋友亲眼所见，一点不夸张。这位平时人设太完美了，但私下真的很难搞。感谢每日大瓜给了匿名投稿的渠道，让真相有机会浮出水面。',
    likes: '1.5k',
    tag: '最新爆料',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm text-foreground-500">
            来自吃瓜群众的一线反馈，每条评论都真实有料
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-lg flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-600 whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3 flex-1">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-accent-500"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 text-center">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium hover:bg-secondary-200 transition-colors cursor-pointer">
            <i className="ri-chat-smile-2-line"></i>
            <span>查看更多评论</span>
          </div>
        </div>
      </div>
    </section>
  );
}